import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

export const BrandLogo = ({ onClick, small = false }) => {
  const size = small ? "text-xl" : "text-2xl";
  return (
    <div
      data-testid="tabdine-logo"
      onClick={onClick}
      className={`font-heading font-bold ${size} tracking-tight cursor-pointer select-none flex items-center gap-1.5`}
    >
      <span className="inline-block w-2.5 h-2.5 rounded-sm bg-brand-orange rotate-45" />
      <span className="text-brand-dark">tab</span>
      <span className="text-brand-orange">dine</span>
    </div>
  );
};

export const RatingStars = ({ value = 0, size = 14 }) => {
  const rounded = Math.round(value * 2) / 2;
  return (
    <span
      className="inline-flex items-center gap-0.5"
      title={`${value} / 5`}
      style={{ fontSize: size }}
      data-testid="rating-stars"
    >
      {[1, 2, 3, 4, 5].map((i) => (
        <span key={i} style={{ color: i <= rounded ? "#F59E0B" : "#E5E7EB" }}>
          ★
        </span>
      ))}
    </span>
  );
};

export const OpenBadge = ({ open }) => (
  <span
    className={`text-xs font-medium px-2 py-0.5 rounded-full ${
      open ? "bg-green-100 text-green-800" : "bg-gray-200 text-gray-700"
    }`}
    data-testid="open-badge"
  >
    {open ? "Open" : "Closed"}
  </span>
);

export const CustomerHeader = ({ hideNav = false }) => {
  const navigate = useNavigate();
  const [taps, setTaps] = React.useState(0);
  const tapRef = React.useRef(null);
  const onLogo = () => {
    if (tapRef.current) clearTimeout(tapRef.current);
    const n = taps + 1;
    setTaps(n);
    if (n >= 7) {
      setTaps(0);
      navigate("/?open=admin");
      window.location.reload();
      return;
    }
    tapRef.current = setTimeout(() => setTaps(0), 1200);
  };
  return (
    <header className="sticky top-0 z-40 bg-brand-light/90 backdrop-blur-md border-b border-brand-dark/10">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">
        <div onClick={onLogo}>
          <BrandLogo onClick={() => navigate("/")} />
        </div>
        {!hideNav && (
          <nav className="flex items-center gap-4 text-sm">
            <Link
              to="/business"
              className="hidden sm:inline text-brand-dark/70 hover:text-brand-orange"
              data-testid="nav-business"
            >
              For Restaurants
            </Link>
            <Link
              to="/profile"
              className="text-brand-dark/70 hover:text-brand-orange"
              data-testid="nav-profile"
            >
              Profile
            </Link>
          </nav>
        )}
      </div>
    </header>
  );
};

export const EmptyState = ({ title, subtitle, children }) => (
  <div className="text-center py-16 px-4">
    <div className="text-5xl mb-3 opacity-40">◍</div>
    <div className="font-heading font-semibold text-lg text-brand-dark">
      {title}
    </div>
    {subtitle && (
      <div className="text-sm text-brand-dark/60 mt-1 max-w-sm mx-auto">
        {subtitle}
      </div>
    )}
    {children && <div className="mt-4">{children}</div>}
  </div>
);
